import styled from 'styled-components';

export const SubmissionStyled = styled.section`
  padding: 16px 24px;
  width: 100%;
  min-width: 0;
  height: 100dvh;
  overflow-y: auto;
  box-sizing: border-box;
`;

export const SubmissionHeaderStyled = styled.header`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  row-gap: 8px;
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e5e5e5;
  width: 100%;
  min-width: 0;

  h2 {
    margin: 0;
    padding: 0;
  }
`;

export const SubmissionHeaderDetailStyled = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  row-gap: 16px;
  width: 100%;
  min-width: 0;
  color: #707171;
`;

export const SubmissionNameStyled = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  row-gap: 4px;
`;

export const SubmissionSchoolStyled = styled.div`
  font-weight: 600;
`;

export const SubmissionDateStyled = styled.div`
  flex-shrink: 0;
  justify-self: flex-end;
  margin-left: auto;
`;

export const SubmissionAssignedDataStyled = styled.div`
  display: grid;
  justify-content: flex-start;
  align-items: flex-start;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 24px;
  row-gap: 16px;
  margin-bottom: 24px;
  padding-bottom: 24px;
  border-bottom: 1px solid #e5e5e5;
  width: 100%;
  min-width: 0;
`;
